import { API_DOMAIN } from './constants';

export const userGateway = API_DOMAIN;
const SAGA_API = process.env.REACT_APP_SAGA_API;

// export const environmentVariable = process.env.REACT_APP_ENVIRONMENT;
// const sagaDepartment = environmentVariable === 'VJAA' ?
//   process.env.REACT_APP_VJAA_SAGA : process.env.REACT_APP_HISOFT_SAGA
const apiLinks = {
  auth: {
    token: `${userGateway}/api/Users/Login`,
  },
  admin: {
    userManagement: {
      getSearch: `${userGateway}/api/users/search`,
      updateUser: `${userGateway}/api/users/update`,
      createUser: `${userGateway}/api/users/create`,
      getUserDetail: `${userGateway}/api/users/detail`,
      getUserProfile: `${userGateway}/api/users/profile`,
      resetPassword: `${userGateway}/api/users/update/reset-password`,
      changePassword: `${userGateway}/api/users/update/password`,
      changeStatus: `${userGateway}/api/users/update/status`,
      confirmChangePassword: `${userGateway}/api/users/confirmchangepassword`,
      forgetPassword: `${userGateway}/api/users/forgetpassword`,
    },

    roleManagement: {
      getSearch: `${userGateway}/api/roles/search`,
      createRole: `${userGateway}/api/roles/create`,
      updateRole: `${userGateway}/api/roles/update/`,
      updateRoleStatus: `${userGateway}/api/roles/update/status/`,
      getRoleDetail: `${userGateway}/api/roles/detail/`,
    },

    moduleManagement: {
      getSearch: `${userGateway}/api/module/search`,
      module: {
        get: `${userGateway}/api/Module?`,
        create: `${userGateway}/api/module`,
        getdetail: `${userGateway}/api/module/detail/`,
        getModuleCurrent: `${userGateway}/api/module/current`,
        getImage: `${userGateway}/Images/`,
        update: `${userGateway}/api/module/update/`,
        updateStatus: `${userGateway}/api/module/update/status/`,
        delete: `${userGateway}/api/Module/Update/`,
      },
    },
    logManagement: {
      getLog: `${userGateway}/api/log`,
    },
    departmentManagement: {
      getAll: `${userGateway}/api/department/old/all-user`,
      getAllForAdmin: `${userGateway}/api/department/old/all`,
      getSearch: `${userGateway}/api/department`,
      department: {
        get: `${userGateway}/api/department/old`,
        getdetail: `${userGateway}/api/department/old/detail`,
        // create: `${userGateway}/api/department/old/create`,
        // create: `${sagaDepartment}/api/TaskSaga/SyncDepartment`,
        create: `${SAGA_API}/TaskSaga/SyncDepartment`,

        // create: `https://sagaorchestratorapi.vjaa.edu.vn/api/TaskSaga/SyncDepartment`,
        update: `${userGateway}/api/department/old/update`,
        delete: `${userGateway}/api/department/old/delete`,
      },
    },
    saga: {
      syncUser: `${SAGA_API}/TaskSaga/SyncUser`,
    },
  },
};

export default apiLinks;
